export const FORGE_CUSTOM_FIELD_TYPE_STRING = 'forge.custom.field.string' as const;
export const FORGE_CUSTOM_FIELD_TYPE_NUMBER = 'forge.custom.field.number' as const;

export type ForgeCustomFieldTypes =
	| typeof FORGE_CUSTOM_FIELD_TYPE_STRING
	| typeof FORGE_CUSTOM_FIELD_TYPE_NUMBER;
